import memoize from 'lru-memoize'
import { createValidator, email, required } from 'utility/validation'

const RegisterFormValidation = createValidator({
  recipient_email: [required, email],
})
export default memoize(10)(RegisterFormValidation)
